<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..."
  type="ball-scale-multiple"></ngx-spinner>
<app-header></app-header>
<div #serviceProviderPage class="container-fluid">
  <div class="row">
    <div class="col-6">
      <div class="rackUploadHeading">
          {{'Service Provider Info'}}
      </div>
    </div>
    <div class="col-6 downloadTemplate">
      <div class="addRackInfo">
        <button class="btn btn-dark" (click)="openServiceProvider()">
            {{'Add Service Provider'}}
          </button>
    </div>
    </div>
    </div>
 
  </div>

  <div class="container-fluid">
      <div class="example-container mat-elevation-z8" >
        <mat-table #table [dataSource]="dataSource">
          <ng-container matColumnDef="serviceProviderEn">
            <mat-header-cell *matHeaderCellDef> Service Provider En </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.serviceProvider}} </mat-cell>
          </ng-container>
      
          <!-- Name Column -->
          <ng-container matColumnDef="serviceProviderJp">
            <mat-header-cell *matHeaderCellDef> Service Provider Jp </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.serviceProviderJp}} </mat-cell>
          </ng-container>
      
          <!-- Weight Column -->
          <ng-container matColumnDef="updatedBy">
            <mat-header-cell *matHeaderCellDef> Updated By </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.updatedBy}} </mat-cell>
          </ng-container>
      
          <!-- Symbol Column -->
          <ng-container matColumnDef="updatedDate">
            <mat-header-cell *matHeaderCellDef> Updated Date </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.updatedDate}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef>{{
              "Edit" | translate
            }}</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon (click)="editServiceProvider(element)" class="edit"
                >edit</mat-icon
              >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef>{{'Delete' | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon (click)="deleteServiceProvider(element)"  class="delete">delete</mat-icon>
            </mat-cell>
          </ng-container>
      
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
     
      </div>
   
    </div>



  